import ChatFileItem from "./ChatFileItem";
export default ChatFileItem;
